(() => {
const normalize = value => value.toUpperCase().replace(/[^A-Z0-9]/g, '');
const init = () => document.querySelectorAll('dialog.tns-finder').forEach(root => {
 if(root.dataset.ready) return;
 root.dataset.ready='true';
 const form=root.querySelector('form'), input=form.elements.model, cards=[...root.querySelectorAll('.tns-finder-result')], count=root.querySelector('.tns-finder-count'), more=root.querySelector('.tns-more');
 let limit=12;
 const render=()=>{
  const query=normalize(input.value);
  cards.forEach(card=>card.hidden=true);more.hidden=true;
  if(query.length<2){count.textContent=root.dataset.prompt;return;}
  const exact=cards.filter(card=>card.dataset.model===query);
  const found=exact.length?exact:cards.filter(card=>card.dataset.model.includes(query));
  found.slice(0,limit).forEach(card=>card.hidden=false);
  count.textContent=found.length?root.dataset.countLabel.replace('{shown}',Math.min(limit,found.length)).replace('{total}',found.length):root.dataset.empty;
  more.hidden=found.length<=limit;
 };
 const open=()=>{if(!root.open)root.showModal();input.focus();};
 document.addEventListener('click',event=>{const link=event.target.closest('a[href]');if(link&&new URL(link.href,location.href).hash==='#tns-finder'){event.preventDefault();open();}});
 root.querySelector('.tns-finder-close').addEventListener('click',()=>root.close());
 root.addEventListener('click',event=>{if(event.target===root){const r=root.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)root.close();}});
 form.addEventListener('submit',event=>{event.preventDefault();limit=12;render();});
 input.addEventListener('input',()=>{limit=12;render();});
 more.addEventListener('click',()=>{limit+=12;render();});
 render();if(location.hash==='#tns-finder')open();
});
init();document.addEventListener('shopify:section:load',init);
})();
